<template>
  <footer class="bg-primary row d-flex text-white content-fluid">
    <div class="divContenedorFooter justify-content-between mx-auto">
      <div class="divSubContenedorFooter pFooter">
        <p class="font36 fw-bold">¡Escríbenos!</p>
        <div class="input-group flex-nowrap w-full mt10">
          <input type="text" v-model="email" class="form-control" placeholder="Escribe tu e-mail">
          <span v-if="isEmailValid" class="input-group-text" id="addon-wrapping" @click="handleSendMail">
            <img src="../../../public/assets/images/icons/mail.svg" alt="">
          </span>
        </div>
        <p v-if="email && !isEmailValid" class="text-danger">Por favor, ingresa un correo electrónico válido.</p>
        <div class="my40">
          <img src="../../../public/assets/images/icons/Fb.svg" width="48px" height="48px" class="cursorPointer"
            @click="redirectToFacebook">
          <img src="../../../public/assets/images/icons/Insta.svg" width="48px" height="48px"
            class=" cursorPointer  mx25" @click="redirectToInstagram">
          <img src="../../../public/assets/images/icons/RRSS_Whatsapp.svg" width="48px" height="48px"
            class="cursorPointer" @click="redirectToWhatsApp">
        </div>
        <div class="font16 d-none d-md-block">
          <p class="">@Copyright 2024-2026 FRIAX</p>
          <p class="">Política de privacidad</p>
        </div>
      </div>
      <div class="divSubContenedorFooter pFooter d-grid mb50 fw600  d-none d-md-block">
        <div class="d-flex mb50">
          <img src="../../../public/assets/images/icons/Celular.svg" alt="" class="text-white mt5" width="26px"
            height="26px">
          <div class="ml10">
            <p class="font25 text-uppercase">CONTACTO</p>
            <p class="font16 lh150Porcent">(614) 366 9958</p>
            <p class="font16 lh150Porcent">friaxconstrucciones@hotmail.com</p>
          </div>
        </div>
        <div class="d-flex mb50">
          <img src="../../../public/assets/images/icons/Locacion.svg" alt="" class="text-white mt5" width="26px"
            height="26px">
          <div class="ml10">
            <p class="font25 text-uppercase">Oficinas</p>
            <p>Av. Homero 1800, Campus Uach II, 31125 Chihuahua, Chih.</p>
          </div>
        </div>
        <div class="d-flex">
          <img src="../../../public/assets/images/icons/Horario.svg" alt="" class="text-white mt5" width="26px"
            height="26px">
          <div class="ml10">
            <p class="font25 text-uppercase">horario</p>
            <p class="font16 lh150Porcent">Lun - Vie</p>
            <p class="font16 lh150Porcent">9:00am - 5:00pm</p>
            <p class="font16 lh150Porcent">Sáb - Dom</p>
            <p class="font16 lh150Porcent">11:00 am - 4:00 pm</p>
          </div>
        </div>
      </div>
      <div class="divSubContenedorFooter pFooter d-grid gap30 mb50 fw600  d-md-none d-block  ">
        <div class="row">
          <div class="col-12 row justify-content-center">
            <img src="../../../public/assets/images/icons/Celular.svg" alt="" class="w-fc text-white mt5" width="26px"
              height="26px">
            <p class="w-fc font25 text-uppercase">CONTACTO</p>
          </div>
          <div class="col-12 row">
            <p class="font16 lh150Porcent">(614) 366 9958</p>
            <p class="font16 lh150Porcent">friaxconstrucciones@hotmail.com</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 row justify-content-center">
            <img src="../../../public/assets/images/icons/Locacion.svg" alt="" class="w-fc text-white mt5" width="26px"
              height="26px">
            <p class="w-fc font25 text-uppercase">OFICINAS</p>
          </div>
          <div class="col-12 row">
            <p>Av. Homero 1800, Campus Uach II, 31125 Chihuahua, Chih.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 row justify-content-center">
            <img src="../../../public/assets/images/icons/Horario.svg" alt="" class="w-fc text-white mt5" width="26px"
              height="26px">
            <p class="w-fc font25 text-uppercase">horario</p>
          </div>
          <div class="col-12 row">
            <p class="font16 lh150Porcent">Lun - Vie</p>
            <p class="font16 lh150Porcent">9:00am - 5:00pm</p>
            <p class="font16 lh150Porcent">Sáb - Dom</p>
            <p class="font16 lh150Porcent">11:00 am - 4:00 pm</p>
          </div>
        </div>
      </div>
      <div class="divSubContenedorFooter pFooter">
        <Mapa class="w-full mapaFooter" />
      </div>
      <div class="divPoliticas d-md-none d-block  pFooter">
        <p class="">@Copyright 2024-2026 FRIAX</p>
        <p class="">Política de privacidad</p>
      </div>
      <!-- Toast -->
      <div class="toast-container position-fixed top-0 end-0 p-3">
        <div class="toast" id="feedbackToast" ref="feedbackToast" role="alert" aria-live="assertive" aria-atomic="true">
          <div class="toast-header">
            <strong class="me-auto">{{ toastTitle }}</strong>
          </div>
          <div class="toast-body text-dark">
            {{ toastMessage }}
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Mapa from '../Mapa.vue';
import { data } from '../../data/configApp';
import { useEmail } from '../logicas/useEmail';

export default {
  name: 'Footer',
  components: {
    Mapa
  },
  setup() {
    const { handleSendMail, toastTitle, toastMessage, showToast, closeToast } = useEmail();

    return {
      handleSendMail,
      toastTitle,
      toastMessage,
      showToast,
      closeToast
    };
  },
  data() {
    return {
      email: "",
      googleId: data.VUE_APP_GOOGLE_ID,
      mailFriax: data.VUE_APP_MAIL_FRIAX,
      telefonoFriax: data.VUE_APP_TELEFONO_FRIAX,
      messageWhatsappFriax: data.VUE_APP_MESSAGE_WHATSAPP_FRIAX,
    };
  },
  computed: {
    isEmailValid() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(this.email);
    }
  },
  methods: {
    redirectToInstagram() {
      window.open(data.VUE_APP_FACEBOOK, '_blank');
    },
    redirectToFacebook() {
      window.open(data.VUE_APP_INSTAGRAM, '_blank');
    },
    redirectToWhatsApp() {
      const newMessage = encodeURIComponent(this.messageWhatsappFriax);
      let url = 'https://wa.me/' + this.telefonoFriax + '?text=' + newMessage;
      window.open(url, '_blank');
    },
    async handleSendMail() {
      await this.handleSendMail(this.mailFriax, "Informes sobre FRIAX - Footer", `Este correo: ${this.email} desea recibir información sobre FRIAX`);
    }
  }
};
</script>